import { MovieMinusIcon } from './MovieMinusIcon';

/**
 * author: Colton Wiscombe
 * id 8437938B-8D4E-4CE9-BE88-D5BBBC39140A
 * name movie-minus
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-minus.svg
 * tags
 * - Video / Movie 
 */
export const ClapperboardMinusIcon = MovieMinusIcon;
export default ClapperboardMinusIcon